import { createResource } from 'react-resource-router';

import { assert, AssertionError } from '@atlassian/eoc-common';

import { fetchDownloadLinkEndpoint } from '../endpoints';

export const downloadAuditLogsResource = createResource<string>({
	type: 'download-audit-logs-resource',
	getKey: () => 'download-audit-logs-resource',
	getData: async (routerContext) => {
		const uniqueKey = routerContext.match.params.exportUniqueKey;
		assert(
			!!uniqueKey,
			new AssertionError('downloadAuditLogs resource', 'uniqueKey must be defined'),
		);

		return fetchDownloadLinkEndpoint(uniqueKey);
	},
	maxAge: 0,
	isBrowserOnly: true,
});
